import React from "react";
import { Helmet } from "react-helmet";

export default class GrindingPage extends React.Component
{
    render () {
        return (
            <article>
                <Helmet title={"Messerschleiferei und Scherenschleiferei"} />

                <div className="is-flex">
                    <div>
                        <h1>Scharfe Klinge – Messer- und Scherenschleiferei</h1>

                        <p>
                            Unter dem Namen „Scharfe Klinge“ schleifen und schärfen wir Ihre Messer und Scheren. Wir
                            sind Ihre kostengünstige Messerschleiferei im Bezirk Feldkirch, in Liechtenstein und
                            Umgebung. Für gewerbliche und private Kunden.
                        </p>

                        <p>
                            Nach telefonischer Vereinbarung (<a href="tel:+436605354277">+43 660 53 54 277</a>) holen
                            wir Ihre Messer und Scheren großer Geräte gerne persönlich bei Ihnen zu Hause ab.
                        </p>

                        <p>
                            Auch außerhalb der Geschäftszeiten, und inkl. Demontage, wenn gewünscht. Als große Geräte
                            verstehen wir z.B. Rasenmäher, Häcksler udgl.
                        </p>

                        <h2>Öffnungszeiten</h2>

                        <p>
                            Mo.–Fr. 14:00–17:00 Uhr
                        </p>
                    </div>

                    <div>
                        <iframe src={"https://www.google.com/maps/embed?pb=!1m2!2m1!1sScharfe+Klinge+–+Messer-+%26+Scherenschleiferei"} />
                    </div>
                </div>
            </article>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/schleiferei.js